import {NAME} from './constants'

export const  SEND_ACTION = NAME + 'SEND_ACTION';


